/** Unwrap `{ success, data }` service envelopes from the .NET API. */
export const unwrapApiData = <T>(payload: unknown): T | null => {
  if (payload === null || payload === undefined) return null;
  if (typeof payload !== 'object') return payload as T;
  const o = payload as Record<string, unknown>;
  if ('data' in o && o.data !== undefined && o.data !== null) {
    return o.data as T;
  }
  return payload as T;
};

/** Unwrap envelope then coerce to a non-empty string (or null). */
export const unwrapApiString = (payload: unknown): string | null => {
  const inner = unwrapApiData<unknown>(payload) ?? payload;
  if (typeof inner === 'string' && inner.trim().length > 0) return inner.trim();
  if (inner && typeof inner === 'object') {
    const o = inner as Record<string, unknown>;
    for (const key of ['token', 'name', 'endpoint', 'url', 'key', 'apiKey']) {
      const v = o[key];
      if (typeof v === 'string' && v.trim().length > 0) return v.trim();
    }
  }
  return null;
};

/** Unwrap list API payloads: raw array or common envelope keys. */
const LIST_KEYS = ['data', 'items', 'transactions', 'payouts', 'settlements', 'results'] as const;

export const asArray = <T>(payload: unknown): T[] => {
  if (Array.isArray(payload)) return payload;
  const unwrapped = unwrapApiData<unknown>(payload);
  if (Array.isArray(unwrapped)) return unwrapped;
  if (payload && typeof payload === 'object') {
    const o = payload as Record<string, unknown>;
    for (const key of LIST_KEYS) {
      if (Array.isArray(o[key])) return o[key] as T[];
    }
  }
  return [];
};
